const $ = window.jQuery;
const $window = window.$window || $(window);
import '../../../assets/js/vendors/jquery.cookieBar.min.js'

const cookieBar = {
    init() {
        // cookiebar
        $('.cookie-message').cookieBar({
            closeButton: '.cookie-close',
            hideOnClose: false,
            secure: true,
            name: 'cookiemessagebar',
        })
        $('.cookie-message').on('cookieBar-close', function () {
            $(this).slideUp()
        })
        $('.customize-cookies').click(function () {
            $('.cookie-message').addClass('slide-out')

            setTimeout(function () {
                $('.cookie-message').removeClass('slide-out')
            }, 1000)

            setTimeout(function () {
                $('.cookie-start').hide()
                $('.cookie-settings').show()
            }, 1000)
        })
    },
};

export default cookieBar;
